import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { asyncActions, actionsGeneratorV2 } from '@docavenue/core';
import { AmcRemainingCostContractDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { useCurrentUser } from '@docavenue/components';

const amcRemainingCostAction = actionsGeneratorV2({
  resource: 'amc-remaining-cost/contract',
  scope: 'pat',
});

const useRemainingCostInsuranceContract = (cardId?: string) => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();

  return useQuery({
    queryKey: ['remainingCostInsuranceContract', cardId, currentUser?.id],
    enabled: !!(cardId && currentUser?.id),
    refetchOnWindowFocus: false,
    queryFn: () =>
      asyncActions<AmcRemainingCostContractDTO>(
        dispatch,
        amcRemainingCostAction.getList(),
      ),
  });
};

export default useRemainingCostInsuranceContract;
